import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import {
  CourseAdmin,
  PaginationData,
  SubGroup,
} from "src/app/shared/interfaces/orgadmin/course-organization";

export const coursePrefix = "[Courses Admin List]";

const coursesAdminListActions = {
  request: `${coursePrefix} Load`,
  requestInit: `${coursePrefix} Init Subscriptions`,
  requestSuccess: `${coursePrefix} Load active success`,
  requestFail: `${coursePrefix} Load fail`,
  requestUpdateSubgroup: `${coursePrefix} Update Subgroup`,
  requestSearch: `${coursePrefix} Search`,
  requestReset: `${coursePrefix} Reset`,
};

export const coursesAdminListLoad = createAction(
  coursesAdminListActions.request,
  props<{
    id: string;
    page?: number;
    size?: number;
    search?: string;
    active: boolean;
  }>(),
);

export const coursesAdminInitSubscriptions = createAction(
  coursesAdminListActions.requestInit,
  props<{
    organizationId: string;
    search?: string;
  }>(),
);

export const coursesAdminSearch = createAction(
  coursesAdminListActions.requestSearch,
  props<{
    id: string;
    page?: number;
    size?: number;
    search?: string;
    active: boolean;
  }>(),
);
export const coursesAdminReset = createAction(
  coursesAdminListActions.requestReset,
  props<{
    active: boolean;
  }>(),
);

export const coursesAdminListLoadSuccess = createAction(
  coursesAdminListActions.requestSuccess,
  props<{
    coursesList: PaginationData<CourseAdmin>;
    orgId: string;
    active: boolean;
    search: string | null;
  }>(),
);

export const loadTeachersFailure = createAction(
  coursesAdminListActions.requestFail,
  props<{ error: HttpErrorResponse }>(),
);

export const updateActiveTeachersSubgroup = createAction(
  coursesAdminListActions.requestUpdateSubgroup,
  props<{
    teachers: SubGroup;
    courseAdminId: string;
  }>(),
);
